import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';
import { EAnchorBlock } from '../../../repositories/price-estimator/entities/onboardings/TooltipSchema';

import * as styles from './styles.css';

interface IOfferHistoryProps {
  title: string;
  fullscreenViewBtn?: React.ReactElement;
  fullscreenView: React.ReactElement;
  offersTableSmall: React.ReactElement;
  tabs?: React.ReactElement;
}

export const OfferHistory: React.FC<IOfferHistoryProps> = ({
  title,
  offersTableSmall,
  fullscreenViewBtn,
  fullscreenView,
  tabs,
}) => {
  return (
    <div id={EAnchorBlock.OffersHistory} className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading1>{title}</UIHeading1>
      </div>
      {tabs}
      {offersTableSmall}
      {fullscreenViewBtn}
      {fullscreenView}
    </div>
  );
};
